export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-shape/src/order/none.js
// module id = h5Jt
// module chunks = 0